import axios from "axios";

export interface ProdutoBusca {
  id: number;
  codigo: number;
  descricao: string;
  precoCompra: number;
  estoque: number;
  codigosDeBarras: string[];
}

interface PageResult {
  isSuccess: boolean;
  data: ProdutoBusca[];
  total: number;
  pageIndex: number;
  pageSize: number;
  message?: string;
}

const pedidosCompraService = {
  /**
   * Busca produtos para adicionar ao pedido de compra
   * @param filter - Termo de busca (código, descrição ou código de barras)
   * @param pageIndex - Índice da página (base 0)
   * @param pageSize - Quantidade de itens por página
   */
  buscarProdutos: async (
    filter: string,
    pageIndex: number = 0,
    pageSize: number = 20
  ): Promise<PageResult> => {
    const { data } = await axios.get<PageResult>(
      "/api/pedidos/buscar-para-pedido",
      {
        params: {
          filter,
          pageIndex,
          pageSize,
        },
      }
    );

    return data;
  },
};

export default pedidosCompraService;
